import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** FETCH GOLD PRICE DETAILS START *********************** */
export const requestReportDetailsFetch = (fetchData: any) => {
	const data = {
		FetchGoldPriceDetailsReportToken: fetchData,
	};
	const url = `${API_URL}GetGoldPriceLog`;
	return makeApiCall(url, data);
};
/** ***************** FETCH GOLD PRICE DETAILS END *********************** */
